import useUrlParams from './useUrlParams'
import { get } from 'browser-cookies'

interface QueryParam {
  isFeatureEnabled?: string
}

const useFeatureFlag: () => [boolean] = () => {
  const [urlParams] = useUrlParams<QueryParam>()
  const { isFeatureEnabled } = urlParams
  const cookie = get('featureFlag') || undefined

  return [isFeatureEnabled === 'true' || cookie === 'true']
}

export default useFeatureFlag
